var ConnectionType = /* @__PURE__ */ ((ConnectionType2) => {
  ConnectionType2["Mobile"] = "mobile";
  ConnectionType2["Corporate"] = "corporate";
  ConnectionType2["VPN"] = "VPN";
  ConnectionType2["Cloud"] = "cloud";
  ConnectionType2["Proxy"] = "proxy";
  ConnectionType2["Residential"] = "residential";
  ConnectionType2["Hosting"] = "hosting";
  ConnectionType2["Cellular"] = "cellular";
  ConnectionType2["Business"] = "business";
  return ConnectionType2;
})(ConnectionType || {});
export {
  ConnectionType
};
//# sourceMappingURL=connectionType.js.map
